function isSymbol(value) {
    return typeof value === 'symbol';
}

export { isSymbol };
